import { Trophy } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Badge } from '@/components/ui/badge';

interface BadgeMenuProps {
  badges: any[];
}

const BadgesMenu = ({ badges }: BadgeMenuProps) => {
  const isMobile = window.innerWidth < 768;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="flex items-center hover:bg-[#106ebe] px-2 h-[50px] transition-colors rounded md:ml-4 md:-mr-2"
          aria-label={`${badges.length} badges`}
        >
          <Badge className="bg-green-600 hover:bg-green-700 text-white cursor-pointer gap-1">
            <Trophy className="h-3 w-3" />
            {!isMobile && <span>{badges.length} badges</span>}
          </Badge>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 mt-2">
        {badges.map((badge: any) => (
          <div key={badge.title} className="flex items-center p-3 border-b border-border last:border-0">
            <img src={badge.icon} alt={badge.title} className="mr-3 w-12 h-12 object-contain" />
            <div>
              <h3 className="font-semibold text-sm m-0">{badge.title}</h3>
              <p className="text-sm text-muted-foreground mt-1 m-0">{badge.description}</p>
            </div>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default BadgesMenu;
